export default __webpack_public_path__ + "static/media/hackneyfoodbank.701e1608.jpg";